import React, { FunctionComponent } from 'react';

import { default as MuiGrid, GridProps } from '@mui/material/Grid';

const Grid: FunctionComponent<GridProps> = ({
  sx,
  children,
  container,
  spacing,
  item,
  xs,
  md,
  lg,
}: GridProps) => {
  return (
    <MuiGrid
      sx={sx}
      container={container}
      spacing={spacing}
      item={item}
      xs={xs}
      md={md}
      lg={lg}
    >
      {children}
    </MuiGrid>
  );
};

export default Grid;
